<template>
	<div class="about">
		<div class="col-6 icon">
			<img>		
		</div>
		<div class="col-6 intro">
			<div class="text">
				The team of aspiring cybersecirity enthusiasts working and joined together in the Cybersecirity bootcamp created by the Azebaijan Institute of Education
			</div>
		</div>
	</div>    
</template>

<script>
export default {    
    name: 'About'
}
</script>